import type { Component, JSX } from "solid-js";
import { onCleanup, onMount, Show } from "solid-js";
import { twJoin } from "tailwind-merge";
import { CloseBtn } from "~/solidJs/entities/SolidModalView/ui/CloseBtn";
import classes from "./LayoutSolidModalView.module.scss";

export type LayoutSolidModalViewProps = {
	children: JSX.Element;
	toggleSelf?: (isShown: boolean) => void;
	autoCloseInit?: boolean;
	class?: string;
};

export const LayoutSolidModalView: Component<LayoutSolidModalViewProps> = (props) => {
	onMount(() => {
		const hide = (e: KeyboardEvent) => {
			if (e.which === 27) {
				e.preventDefault();
				props.toggleSelf?.(false);
			}
		};
		if (props.toggleSelf) {
			document.addEventListener("keydown", hide);
		}
		onCleanup(() => {
			document.removeEventListener("keydown", hide);
		});
	});
	return (
		<div
			data-test={"modal-veiw"}
			class={twJoin(classes.modalView, props.class)}
			onClick={(_e) => {
				props.toggleSelf?.(false);
			}}
		>
			<Show when={props.autoCloseInit}>
				<CloseBtn
					onClick={(e) => {
						e.stopPropagation();
						props.toggleSelf?.(false);
					}}
				/>
			</Show>
			{props.children}
		</div>
	);
};
